<template>
  <div>
    <a-form-model-item style="width:255px" label="附件：" prop="fileId">
      <div style="position:relative">
        <qiXinKaiLiFileUpload
          accept=".png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.pdf,.PDF,.zip,.ZIP"
          ref="fileUpload"
          :paramObj.sync="uploadParam"
          @uploadOk="uploadOk"
          name="file"
          limit="50"
        />
        <div class="text-color-orange img-tip">
 温馨提示：1、每次上传最多不超过50个文件
 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、支持PNG、JPG、JPEG、PDF、ZIP，单个文件不能超过100M
        </div>
      </div>
    </a-form-model-item>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import qiXinKaiLiFileUpload from '@/components/ui/qxkl-file-upload/index'

export default {
  props: {
    info: {
      type: [Object],
      default: function() {
        return {};
      }
    },
  },
  components: {qiXinKaiLiFileUpload},
  data() {
    return {
      invData: {},
      invDataList:[],

      uploadParam: {
        app: "portal-pc",
        module: "payable",
        user: this.$store.getters["home/getUserHeader"].realname,
        tblBlId: this.utils.guid(32, 16),
        mdlId: "10068",
        fileTpCd: "5"
      }

    };
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj"
    })
  },
  created() {},
  methods: {
    ...mapActions({
      getDicAsync: "app/getDicAsync"
    }),
    initData() {
      this.tableData = [];
      this.uploadParam.tblBlId = this.utils.guid(32, 16);
      if(this.$refs.fileUpload){
        this.$refs.fileUpload.initData()
      }
    },
    uploadOk(resList) {
      this.$emit('receiveFileTblBlId', this.uploadParam.tblBlId);
    }

  },
  watch: {},
  activated() {}
};
</script>
<style scoped lang="less">
.img-tip {
  white-space: pre-wrap;
  position: absolute;
  left: 120px;
  font-size: 12px;
  top: -10px;
  width: 430px;
  line-height: 15px;
}
/deep/ .ant-table-body {  //样式穿透
  overflow-x: auto !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/bill-manage/payable/other-file-upload.vue